import { useCallback } from 'react';

import { changeChatMessage } from 'store/notifications/slicer';
import { NotificationEntities } from 'utils/enums';

import useDispatch from './useDispatch';
import useCooperativeId from './useCooperativeId';

export const useUpdateCaseNotifications = () => {
  const cooperativeId = useCooperativeId();
  const dispatch = useDispatch();

  const updateCaseNotifications = useCallback(() => {
    if (cooperativeId) {
      dispatch(
        changeChatMessage({
          coopId: cooperativeId,
          entities: [NotificationEntities.Incident],
        })
      );
    }
  }, [dispatch, cooperativeId]);

  return updateCaseNotifications;
};
